import { extractStatusCode, toRtkErrorShape } from "~/helpers/rtkErrorClassification";
import { AUTH_HEADER_KEYS, extractGraphQLErrorSummary, sanitizeResponseSnippet } from "~/services/graphqlErrorHelpers";

function redactingReplacer(key: string, value: unknown): unknown {
	if (AUTH_HEADER_KEYS.has(key.toLowerCase())) return "[REDACTED]";
	return value;
}

function formatLogError(error: unknown): string {
	if (error === undefined) return "undefined";
	if (error === null) return "null";

	if (error instanceof Error) {
		const header = `${error.name || "Error"}: ${error.message}`;
		return error.stack ? `${header}\n${error.stack}` : header;
	}

	if (typeof error !== "object") return String(error);

	const rtk = toRtkErrorShape(error);
	const status = extractStatusCode(rtk);
	const gqlSummary = extractGraphQLErrorSummary(rtk);
	const snippet = sanitizeResponseSnippet(rtk);

	if (status !== undefined || gqlSummary || snippet) {
		const parts: string[] = [];
		if (status !== undefined) parts.push(String(status));
		if (gqlSummary) parts.push(gqlSummary);
		else if (snippet) parts.push(snippet);
		if (parts.length) return parts.join(": ");
	}

	try {
		return JSON.stringify(error, redactingReplacer, 2);
	} catch {
		return String(error);
	}
}

export default formatLogError;
